import { render } from "./RequestImkpModal.vue?vue&type=template&id=3db57bd4&scoped=true"
import script from "./RequestImkpModal.vue?vue&type=script&lang=js"
export * from "./RequestImkpModal.vue?vue&type=script&lang=js"

import "./RequestImkpModal.vue?vue&type=style&index=0&id=3db57bd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db57bd4"]])

export default __exports__